import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Button, Modal, Form, Offcanvas } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import { useAuth } from '../../../context/AuthContext';
import withPermission from '../../../utils/withPermission';
import Swal from 'sweetalert2';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const API_URL = `${backendUrl}/api/holidays`;

const HolidayList = () => {
    const [holiday, setholiday] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ name: '' });
    const [isEdit, setIsEdit] = useState(false);
    const [selectedholiday, setSelectedholiday] = useState(null);
    const didFetchRef = useRef(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const WithListPermission = withPermission(({ children }) => children, ['type-list']);
    const WithCreatePermission = withPermission(({ children }) => children, ['holiday-create']);
    const WithDeletePermission = withPermission(({ children }) => children, ['holiday-delete']);
    const WithEditPermission = withPermission(({ children }) => children, ['holiday-edit']);
    const [searchQuery, setSearchQuery] = useState('');
    const [errors, setErrors] = useState({});

    const debounceTimeoutRef = useRef(null);
    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchholiday(1, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery]);
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };

    const fetchholiday = async (page = 1) => {
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const response = await axios.get(`${API_URL}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: {
                    page,
                    search: searchQuery,
                },
            });
            setholiday(response.data?.data || []);
            setPageCount(response.data.last_page);
            setCurrentPage(response.data.current_page);


        } catch (error) {
            console.error('Error fetching holiday:', error);
        }
    };

    const handleAddholiday = () => {
        setFormData({ name: '', description: '' });
        setIsEdit(false);
        setSelectedholiday(null);
        setShowModal(true);
    };

    const handleEditholiday = (holiday) => {
        setFormData(holiday);
        setIsEdit(true);
        setSelectedholiday(holiday);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;
                    await axios.delete(`${API_URL}/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });
                    setholiday(holiday.filter(holiday => holiday.id !== id));
                    Swal.fire(
                        "Deleted!",
                        "The holiday has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting holiday:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete holiday. Please try again.",
                        "error"
                    );
                }
            }
        });

    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",  // Remove the error message for this field
        }));
    };

    const handlePageChange = ({ selected }) => {
        const newPage = selected + 1;
        setCurrentPage(newPage);
        fetchholiday(newPage);
    };
    useEffect(() => {
        if (!showModal) {
            setErrors({});
        }
    }, [showModal]);

    const validateForm = () => {
    const newErrors = {};
    if (!formData.name?.trim()) {
        newErrors.name = 'Name is required';
    } else {
        const duplicateInstance = holiday.some(
            (contact) =>
                contact?.name &&
                contact.name.toLowerCase() === formData.name.toLowerCase() &&
                contact.id !== (selectedholiday?.id || null)
        );

        if (duplicateInstance) {
            newErrors.name = 'Name must be unique';
        }
    }

    return newErrors;
};

    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        const origin = localStorage.getItem('user-origin');
        const token = userInfo?.token;
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return; // Stop here if validation fails
        }
        try {
            if (isEdit) {
                const response = await axios.put(`${API_URL}/${selectedholiday.id}`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
                setholiday(holiday.map(ind => (ind.id === selectedholiday.id ? response.data.data : ind)));
            } else {
                const response = await axios.post(API_URL, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
                setholiday([...holiday, response.data.data]);
            }
            setShowModal(false);
        } catch (error) {
            console.error('Error saving holiday:', error);
        }
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid ">
                    <div className="row w-100">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Holiday Setup</h4>
                                <div className="page-title-right">

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>



                                        </div>
                                        <WithCreatePermission>
                                            <button
                                                type="button"
                                                className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                                                onClick={handleAddholiday}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title='Add holiday'
                                            >
                                                <i className="mdi mdi-plus" ></i>
                                            </button></WithCreatePermission>
                                    </div>
                                    <table className="table align-middle table-nowrap table-check table-list">

                                        <thead className="table-sales-gradient">
                                            <tr>
                                                <th style={{ width: '20px' }} className="align-middle">
                                                    <div className="form-check font-size-16">
                                                        <input className="form-check-input" type="checkbox" id="checkAll" />
                                                        <label className="form-check-label" htmlFor="checkAll"></label>
                                                    </div>
                                                </th>
                                                <th className="align-middle">#</th>
                                                <th className="align-middle"> Date</th>

                                                <th className="align-middle"> Name</th>

                                                <th className="align-middle">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {holiday.map((holiday, index) => (
                                                <tr key={holiday.id}>
                                                    <td>
                                                        <div className="form-check font-size-16">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id={`instanceCheck${index}`}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor={`instanceCheck${index}`}
                                                            ></label>
                                                        </div>
                                                    </td>
                                                    <td>{index + 1}</td>
                                                    <td>{holiday.date}</td>
                                                    <td>{holiday.name}</td>

                                                    <td>
                                                        <div className="dropdown">
                                                            <i
                                                                className="mdi mdi-dots-horizontal font-size-18"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                                style={{ cursor: 'pointer' }}
                                                            ></i>
                                                            <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                <li>
                                                                    <WithEditPermission>
                                                                        <button className="dropdown-item" onClick={() => handleEditholiday(holiday)}>
                                                                            Edit
                                                                        </button>
                                                                    </WithEditPermission>
                                                                </li>
                                                                <li>
                                                                    <WithDeletePermission>
                                                                        <button className="dropdown-item" onClick={() => handleDelete(holiday.id)}>
                                                                            Delete
                                                                        </button>
                                                                    </WithDeletePermission>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="d-flex justify-content-end pagination-sm">
                                        <ReactPaginate
                                            previousLabel={'<'}
                                            nextLabel={'>'}
                                            breakLabel={'...'}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={handlePageChange}
                                            containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item previous'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item next'}
                                            nextLinkClassName={'page-link'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                        />
                                    </div>
                                    {/* Modal for Add/Edit holiday */}
                                    <Offcanvas show={showModal} onHide={() => setShowModal(false)} placement='end'>
                                        <Offcanvas.Header closeButton>
                                            <Offcanvas.Title>{isEdit ? 'Edit Leave Type' : 'Add Leave Type'}</Offcanvas.Title>
                                        </Offcanvas.Header>
                                        <hr style={{ margin: 0 }} /><br />

                                        <Offcanvas.Body>
                                            <Form>
                                                <Form.Group controlId="holidayDate" className='mb-3'>
                                                    <Form.Label style={{ fontSize: "13px" }}>Date</Form.Label>
                                                    <Form.Control type="date" style={{ fontSize: "13px" }} name="date" value={formData.date} onChange={handleInputChange}
                                                        className='form-control'

                                                    />
                                                    </Form.Group><br />
                                                <Form.Group controlId="holidayName" className='mb-3'>
                                                    <Form.Label style={{ fontSize: "13px" }}>Name</Form.Label>
                                                    <Form.Control type="text" style={{ fontSize: "13px" }} name="name" value={formData.name} onChange={handleInputChange}
                                                        className={`form-control ${errors?.name ? 'is-invalid' : ''}`}

                                                    />
                                                    {errors.name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.name}</div>}
                                                </Form.Group><br />
                                               

                                            </Form>
                                        </Offcanvas.Body>
                                        <div className="p-3 d-flex justify-content-end border-top">
                                            <Button variant="secondary me-2" onClick={() => setShowModal(false)}>Close</Button>
                                            <Button variant="primary" onClick={handleSubmit}>{isEdit ? 'Update' : 'Save'} </Button>
                                        </div>
                                    </Offcanvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HolidayList;
